// extracted by mini-css-extract-plugin
export default {"imageList":"style_imageList__or3YT","title":"style_title__3IseA","images":"style_images__qbu+-"};